import React, { useContext, useEffect, useState } from 'react';
import "./finalproduct.css";
import Navbar from '../Navbar/Navbar';
import Footer from '../footer/Footer';
import { FaStar } from "react-icons/fa";
import { useParams } from 'react-router-dom';
import { Shopcontext } from '../../context/Shopcontext';
import latest1 from "../../images/latest1.webp";

function Finalproduct() {

    const [image, setImage] = useState("");
    const { productId } = useParams();
    const { products } = useContext(Shopcontext);
    const [productdata, setProductdata] = useState(false);

    const fetchdata = async () => {
        products.map((item) => {
            if (item._id == productId) {
                setProductdata(item);
                setImage(item.image[0]);
                return null;
            }
        });
    };

    useEffect(() => {
        fetchdata();
    }, [productId, products]);

    const handleBuyNow = () => {
        if (productdata) {
            const phoneNumber = "+918422051071"; // Replace with your desired WhatsApp number (including country code)
            const message = `
                I would like to buy the following product:

                Name: ${productdata.name}
                Price: ₹${productdata.price}
                Description: ${productdata.description}

                Please contact me for further details.
            `;

            const encodedMessage = encodeURIComponent(message);
            const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

            // Redirect to WhatsApp
            window.open(whatsappURL, "_blank");
        }
    };

    return (
        <>
            <Navbar />
            {productdata ? (
                <div>
                    <div className='finalmaindiv'>
                        <div className='finalmaindivinner'>
                            <div className='finalleft'>
                                <div className='finalsideimgdiv'>
                                    {productdata.image.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`finalsideimginner ${item === image ? "addborder" : ""}`}
                                            onClick={() => { setImage(item); }}
                                        >
                                            <img src={item} alt="product" />
                                        </div>
                                    ))}
                                </div>
                                <div className='finalmainimgdiv'>
                                    <div className='finalmainimgdivinner'>
                                        <img src={image} alt="product" />
                                    </div>
                                </div>
                            </div>
                            <div className='finalright'>
                                <h3>{productdata.name}</h3>
                                <div className='finalratingstar'>
                                    <FaStar size={18} color='#d4af35' />
                                    <FaStar size={18} color='#d4af35' />
                                    <FaStar size={18} color='#d4af35' />
                                    <FaStar size={18} color='#d4af35' />
                                    <FaStar size={18} color='#d4af35' />
                                </div>
                                <div className='finalpricediv'>
                                    <h4 className='finalprice'>₹{productdata.price}</h4>
                                    <strike>₹150</strike> Comp. value
                                </div>
                                <p className='finalmainpara'>{productdata.description}</p>
                                <div className='finalbybtndiv'>
                                    <button className="finalbybtn" onClick={handleBuyNow}>Buy Now</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='finaldesdiv'>
                        <div className='finaldesheading'>
                            <p>Description</p>
                        </div>
                        <div className='finaldespara'>
                            <p>{productdata.description}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <h1>No Data Found</h1>
            )}

            <div className='relatedproductdiv'>
                <h3 className='relatedheading'>RELATED PRODUCTS</h3>
                <div className='relatedinnerdiv'>
                    <div className='relatedimgdiv'>
                        <img src={latest1} alt="related" />
                    </div>
                    <div className='relatedimgdiv'>
                        <img src={latest1} alt="related" />
                    </div>
                    <div className='relatedimgdiv'>
                        <img src={latest1} alt="related" />
                    </div>
                    <div className='relatedimgdiv'>
                        <img src={latest1} alt="related" />
                    </div>
                    <div className='relatedimgdiv'>
                        <img src={latest1} alt="related" />
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default Finalproduct;
